export default class Loader {
    constructor () {
        this.loaderHide()
    }

    loaderHide() : void {
        const loader = document.querySelector('.as__loader')
        loader.classList.add('as__hide')
    }
}